import React, { useEffect, useState } from 'react';
import { MainContainer } from './../Recognition/RecognitionActivity/styles';
import PropTypes from "prop-types";
import { BorderBottom, TabBottomLine, TabWrapper, /*YearlyCard*/ } from './styles';
import { ActiveLibraryTab } from './library/ActiveLibraryTab';
import { InActiveLibraryTab } from './library/InactiveLibraryTab';
import { ArchiveLibraryTab } from './library/ArchiveLibraryTab';

// const dummyData = [
//   { month: 'January', members: generateMembers() },
//   { month: 'February', members: generateMembers() },
//   { month: 'March', members: generateMembers() },
//   { month: 'April', members: generateMembers() },
//   { month: 'May', members: generateMembers() },
//   { month: 'June', members: generateMembers() },
//   { month: 'July', members: generateMembers() },
//   { month: 'August', members: generateMembers() },
//   { month: 'September', members: generateMembers() },
//   { month: 'October', members: generateMembers() },
//   { month: 'November', members: generateMembers() },
//   { month: 'December', members: generateMembers() },
// ];

// function generateMembers() {
//   return Array.from({ length: 6 }, (_, index) => ({
//     name: `Member ${index + 1}`,
//     image: `https://via.placeholder.com/150?text=Member+${index + 1}`,
//     count: Math.floor(Math.random() * 100),
//   }));
// }

const Library = ({ getColor, history, companyInfo,activeTab }) => {
  //   const [showAll, setShowAll] = useState({}); // Initialize as an empty object
  const [activeTabV, setActiveTab] = useState(history.location?.state?.activeTabV ? history.location.state.activeTabV : 'Active');


  useEffect(()=>{
    setActiveTab(history.location?.state?.activeTabV ? history.location.state.activeTabV : 'Active')
    
  },[history.location?.state?.activeTabV])

  //   const handleShowMore = (month) => {
  //     setShowAll((prevState) => ({
  //       ...prevState,
  //       [month]: !prevState[month], // Toggle the state for the specific month
  //     }));
  //   };

  // const handleActiveTab = (tab)=>{
  //   setActiveTab(tab)
  // }

  return (
    <MainContainer margin>
      <TabWrapper>
        <TabBottomLine active={activeTabV === 'Active'} background={getColor} onClick={() => setActiveTab('Active')}>
          Active
          <BorderBottom active={activeTabV === 'Active'} background={getColor} />
        </TabBottomLine>
        <TabBottomLine active={activeTabV === 'Inactive'} background={getColor} onClick={() => setActiveTab('Inactive')}>
          Inactive
          <BorderBottom active={activeTabV === 'Inactive'} background={getColor} />
        </TabBottomLine>
        <TabBottomLine active={activeTabV === 'Archive'} background={getColor} onClick={() => setActiveTab('Archive')}>
          Archive
          <BorderBottom active={activeTabV === 'Archive'} background={getColor} />
        </TabBottomLine>
      </TabWrapper>
      
      {activeTabV === "Active" ? <ActiveLibraryTab activeTab={activeTab}  activeTabV={activeTabV} history={history} companyInfo={companyInfo} setSubTab={setActiveTab} /> : null}
      {activeTabV === "Inactive" ? <InActiveLibraryTab history={history} companyInfo={companyInfo} setSubTab={setActiveTab}  /> : null}
      {activeTabV === "Archive" ? <ArchiveLibraryTab history={history} companyInfo={companyInfo} setSubTab={setActiveTab}  /> : null}
    </MainContainer>
  );
};

Library.propTypes = {
  getColor: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  companyInfo: PropTypes.object.isRequired,
  activeTab: PropTypes.number.isRequired,
};

export default Library;

